var render, staticRenderFns
import script from "./retrievallist.vue?vue&type=script&lang=js&"
export * from "./retrievallist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e540b",
  null
  
)

export default component.exports